export enum QUERY_KEYS {
  CAD_VERSIONS = 'CAD_VERSIONS',
  CAD_VERSION = 'CAD_VERSION',
  METADATA = 'METADATA',
}

export default QUERY_KEYS
